export const USER_LOGIN = "/Accounts/Login";
export const USER_SEND_OTP = "/Accounts/SendOtp";
export const GET_CATEGORIES_LIST = "/Category/GetCategories";
export const ADD_CATEGORY = "/Category/AddCategory";
export const UPDATE_CATEGORY = "/Category/UpdateCategory"
export const GET_CATEGORY_DROPDOWN = "/Category/GetCategory";

export const GET_PRODUCTS_BY_ID = "/Product/GetProduct";
export const GET_PRODUCTS_LIST = "/Product/GetProducts";
export const ADD_PRODUCT = "/Product/AddProduct";
export const UPDATE_PRODUCT = "/Product/UpdateProduct";
export const ADD_OR_UPDATE_PRODUCT_VARIANT = "/Product/AddOrUpdateProductVariant";
export const GET_PRODUCT_VARIENT_DATA = "/Product/GetProductVariantsByProductId";
export const PUBLISH_OR_UNPUBLISH_PRODUCT = "/Product/PublishOrUnPublishProduct";
export const GET_PRODUCTS_LIST_DROPDOWN = "/DropDown/GetAllProductsDropDown";
export const GET_PRODUCTS_VARIENTS_LIST_DROPDOWN = "/DropDown/GetAllProductVarientsDropDown";
export const GET_GST_DROPDOWN = "/DropDown/GetGstDropDown";

export const GET_TOPICS_LIST = "/Topic/GetTopicList";
export const GET_TOPICS_DETAILS_BY_ID = "/Topic/GetTopicDetailsById";
export const ADD_TOPIC = "/Topic/AddTopic";
export const UPDATE_TOPIC = "/Topic/UpdateTopic";
export const DELETE_TOPIC = "/Topic/DeleteTopic";
export const ENABLE_OR_DISABLE_TOPIC = "/Topic/EnableOrDisableTopic";
export const UPDATE_TOPIC_ORDER = "/Topic/UpdateTopicOrderSequence";
export const GET_TOPIC_ITEMS = "/Topic/GetTopicItems";
export const ADD_TOPIC_ITEM = "/Topic/AddTopicItem";
export const DELETE_TOPIC_ITEM = "/Topic/DeleteTopicItem";
export const GET_TOPIC_ADVERTISEMENT_ITEMS = "/Topic/GetAdTopicItems";
export const ADD_TOPIC_ADVERTISEMENT_ITEM = "/Topic/AddTopicAdItem";
export const UPDATE_TOPIC_ADVERTISEMENT_ITEM = "/Topic/UpdateTopicAdItem";
export const DELETE_TOPIC_ADVERTISEMENT_ITEM = "/Topic/DeleteAdTopicItem";

export const GET_CUSTOMERS_LIST = "/ManageCustomers/GetCustomers";
export const ADD_TRENDING_PRODUCT = "/Product/AddTrendingProductVariants";
export const DELETE_TRENDING_PRODUCT = "/Product/DeleteTrendingProductVariant";
export const ENABLE_OR_DISABLE_TRENDING_PRODUCT = "/Product/EnableOrDissableTrendingProductVariant";
export const GET_TRENDING_PRODUCTS = "/Product/GetTrendingProductVariants";
export const ADD_POPULAR_CATEGORY = "/Category/AddPopularCategories";
export const DELETE_POPULAR_CATEGORY = "/Category/DeletePopularCategory";
export const ENABLE_OR_DISABLE_POPULAR_CATEGORY = "/Category/EnableOrDissablePopularCategory";
export const GET_POPULAR_CATEGORIES = "/Category/GetPopularCategories";
export const ADD_RECENT_SEARCH = "/Category/AddRecentSearch";
export const DELETE_RECENT_SEARCH = "/Category/DeleteRecentSearch";
export const ENABLE_OR_DISABLE_RECENT_SEARCH = "/Category/EnableOrDissableRecentSearch";
export const GET_RECENT_SEARCHES = "/Category/GetRecentSearch";

export const GET_ORDERS_LIST = "/AdminOrder/GetOrderList";
export const GET_ORDER_DETAILS = "/AdminOrder/GetOrderDetails";
export const GET_REVIEWS_BY_PRODUCT_VARIANT = "/AdminOrder/GetReviewsByProductVariantId";
export const ADD_PRODUCT_VARIANT_REVIEW = "/AdminOrder/AddReview";


export const GET_BLOGS_LIST = "/Blog/Getblogs";
export const ADD_BLOG_API = "/Blog/AddBlog";
export const GET_BLOG_BY_ID = "/Blog/GetBlog";
export const UPDATE_BLOG = "/Blog/UpdateBlog";
export const DELETE_BLOG = "/Blog/DeleteBlog";
export const GET_NESTED_CATEGORY_DROPDOWN  = "/DropDown/GetNestedCategories";
export const PUBLISH_OR_UNPUBLISH_BLOG  = "/Blog/PublishOrUnPublishBlog";

export const ADD_HSN = "/Gst/AddGst";
export const UPDATE_HSN = "/Gst/UpdateGst";
export const ENABLE_HSN = "/Gst/EnableOrDissableGst";
export const GET_GST = "/Gst/getGsts";

export const GET_DASHBOARD_DATA = "/Dashboard/GetAdminDashboard";